import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, space } = theme

export const Benefits = styled.section`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  background-color: ${colors['blue-background-strong-default']};
`
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  gap: ${space['spacing-md']};
  padding: ${space['spacing-xl']} 8.5rem ${space['spacing-xxl']};

  @media (${media.phone}) {
    padding: ${space['spacing-xl']} ${space['spacing-md']} ${space['spacing-xxl']};
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};
  margin-bottom: ${space['spacing-sm']};
`

export const CardsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space['spacing-sm']};

  @media (${media.tablet}) {
    flex-wrap: nowrap;
  }
`

export const CarouselFull = styled.div`
  @media (${media.phone}) {
    > div:first-child {
      margin-left: calc(${space['spacing-md']} * -2);
      margin-right: calc(${space['spacing-md']} * -2);
    }

    .swiper-slide {
      width: auto;
      opacity: 0.4;
      transition: opacity 0.3s ease;
    }

    .swiper-slide-active {
      opacity: 1;
    }

    .controls-wrapper {
      margin-top: ${space['spacing-md']};
    }
  }
`
